import React, { useState } from "react";
import { Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import file from "config/img/logo.png";
import { bailiffDocumentDetailSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
import numeral from "numeral";
const PaymentInfo = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffDocumentDetailSelector);

  const name = detail?.name;
  const note = detail?.note;
  const duration = detail?.duration;
  const size = detail?.size / 1024 / 1024;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderName = () => {
    return <div>Tên file: {name}</div>;
  };

  const renderDesc = () => {
    return <div>Mô tả: {note}</div>;
  };

  const renderDuration = () => {
    return <div>Thời lượng: {duration}</div>;
  };

  const renderSize = () => {
    return <div>Kích thước: {numeral(size).format("0,0.00")} MB</div>;
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Row className="payment-info">
      <Col className="align-center" xl={6} lg={6} md={12} xs={24}>
        <img src={file} style={{ width: 80, height: 80 }} alt="file" />
      </Col>
      <Col
        style={{ display: "flex", flexDirection: "column", gap: 6 }}
        xl={18}
        lg={18}
        md={12}
        xs={24}
      >
        {renderName()}
        {renderDesc()}
        {renderDuration()}
        {renderSize()}
      </Col>
    </Row>
  );
};
export default PaymentInfo;
